import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';

import { AuthService } from 'src/app/_shared/services';
import * as fromStore from 'src/app/_store/_reducers';

export class SysAdminValidator {
  constructor(protected authService: AuthService, protected store: Store<fromStore.State>, protected router: Router) {}

  validationObservable(): Observable<boolean> {
    return this.authService.renewToken().pipe(
      take(1),
      // switch the stream to the auth observable
      switchMap(() => {
        return this.store.select(fromStore.getIsSysAdmin);
      })
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class SysAdminGuard extends SysAdminValidator {
  constructor(authService: AuthService, protected store: Store<fromStore.State>, router: Router) {
    super(authService, store, router);
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.validationObservable().pipe(
      // re-parse the token to kick off a fresh call to user/account api
      tap((p) => (p === true ? this.authService.reload() : this.router.navigate(['/fleet'])))
    );
  }
}
